import React, { useRef, useEffect } from "react";

const LightGradientBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const drawGradient = () => {
      // Creating the gradient using the provided colors
      const gradient = ctx.createLinearGradient(canvas.width, 0, 0, 0);
      gradient.addColorStop(0, "#b9fbc0"); // Soft Mint
      gradient.addColorStop(0.5, "#fef9c3"); // Pale Yellow
      gradient.addColorStop(1, "#e0aaff"); // Soft Mauve

      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    };

    drawGradient();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      drawGradient();
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }}
    />
  );
};

export default LightGradientBackground;
